import {call, put, select} from "typed-redux-saga";
import {DrawPredictorApi} from "apps/DRAW_PREDICTOR/modules/utils";
import {getFanSentimentsQuestionsWithAnswer} from "apps/DRAW_PREDICTOR/modules/selectors";
import {getUser} from "modules/selectors";
import {showGlobalError} from "modules/actions";
import PersistStorage from "modules/utils/PersistStorage";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {trackAdobeAnalytics} from "modules";
import {reduce, find} from "lodash";

export const saveFanSentimentsSaga = function* () {
	try {
		const sentiments = yield* select(getFanSentimentsQuestionsWithAnswer);
		const user = yield* select(getUser);
		const answers = sentiments.map((sentiment) => {
			return {
				questionId: sentiment.id,
				optionIds: sentiment.answers,
			};
		});

		sentiments.forEach((sentiment) => {
			const answersText = reduce(
				sentiment.answers,
				(result, value, key) => {
					const answer = find(
						sentiment.options || sentiment.playerOptionsArray,
						(option) => value === option.id
					);
					if (!answer) {
						return result;
					}
					return {
						...result,
						[`answer${key + 1}`]: answer.text,
					};
				},
				{}
			);

			trackAdobeAnalytics({
				section: "",
				eventName: "drawAnswerSubmit",
				optional: {
					question: sentiment.question,
					...answersText,
				},
			});
		});

		if (user.id) {
			yield* call(DrawPredictorApi.fan_sentiment.save, {
				answers,
			});
		} else {
			PersistStorage.SET("fanSentiments", answers);
		}

		yield* put(handleModalState({fanSentiments: false}));
		yield* put(handleModalState({drawConfirmation: true}));
	} catch (err) {
		yield* put(showGlobalError(err as Error));
	}
};
